goog.provide("shadow.js.shim.module$src$svg$wpp$content$cart_svg");
goog.provide("module$shadow_js_shim_module$src$svg$wpp$content$cart_svg");
shadow.js.shim.module$src$svg$wpp$content$cart_svg = shadow.js.nativeProvides["src/svg/wpp/content/cart.svg"] = shadow$bridge("src/svg/wpp/content/cart.svg");
module$shadow_js_shim_module$src$svg$wpp$content$cart_svg.default = shadow.js.shim.module$src$svg$wpp$content$cart_svg;
